/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import styled from "styled-components";
import Drawer from "@material-ui/core/Drawer";

const StyledDrawer = styled(Drawer)`
  animation: "none !important";
  transition: "none !important";
  width: ${(props) => props.width}px;
  .MuiDrawer-paper {
    width: ${(props) => props.width}px;
    height: 100vh;
  }
`;

function RightDrawer({ children, width }) {
  return (
    <StyledDrawer
      open={true}
      anchor="right"
      width={width}
      transitionDuration={0}
      SlideProps={{ timeout: 0 }}
      data-testid="right-drawer"
    >
      {children}
    </StyledDrawer>
  );
}

export default RightDrawer;
